//import request from "../../service/httpService";
import { updateField, getField } from "vuex-map-fields";

export default {
    namespaced: true,
    state() {
        return {
            appliance_capabilities: {},
        }
    },
    mutations: {
        updateField,
        setCapabilities(state, payload) {
            state.appliance_capabilities = payload;
        }
    },
    getters: {
        getField,
        capabilities(state) {
            return state.appliance_capabilities;
        },
        capabilityNames(state) {
            return state.appliance_capabilities.map((item) => {
                return item.attributes.capability;
            });
        }
    },

    actions: {

    },

};